export default {
  CODE_TYPE_LESSEE_ELECTRIC_CARD_NO: '1',
  CODE_TYPE_LESSEE_WATER_CARD_NO: '2',
  CODE_TYPE_LESSEE_CODE: '3',
};
